import clientConfig from '@jucy-nakuru/config/clientConfig';
import jCreateLogger, { ChildLoggerOptions, Logger, initLogger } from '@jucy/logger';

initLogger({
    jsonEnabled: clientConfig?.log?.jsonEnabled,
    labelLevel: clientConfig.log?.level,
    traceEnabled: clientConfig.log?.traceEnabled,
});

const createLogger = <ChildOptions extends ChildLoggerOptions>(module: NodeJS.Module | ImportMeta | string, options?: ChildOptions): Logger =>
    jCreateLogger(module, options);

export default createLogger;
